import {
  ListButton,
  LoadMoreButton,
  NewsServiceName,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"
import { Props as CardActionCheckboxProps } from "components/Cards/Card/Actions/Checkbox"
import { memo } from "react"

import Actions from "./Actions"

interface Props {
  clearListButtonProps: ListButton
  isAdmin: boolean
  isEditor: boolean
  loadMoreButtonProps: LoadMoreButton
  listButtonProps: ListButton
  onlyNewProps: CardActionCheckboxProps
  onlyPresentProps: CardActionCheckboxProps
  showFlaggedProps: CardActionCheckboxProps
  serviceName: NewsServiceName | ReviewsServiceName
}

export interface ComponentProps extends Props {}

export default memo(Actions)
